import ScrollService from "../Scroll"

const history = {}

export const scrollHistory = {
    saveCurrent: function() {
        if (!window.history.state) {
            return
        }

        history[window.history.state.random] = {
            scroll: ScrollService.getScroll(),
            height: document.documentElement.offsetHeight
        }
    },
    getCurrent: function() {
        if (!window.history.state) {
            return null
        }
        
        return history[window.history.state.random]
    }
}